import React, { Component } from 'react'

import {parseTimestamp} from '../../utils'

class GenericTable extends Component {

    constructor(props){
        super(props)
        this.state = {
            orderedData: [],
            actualPage: 0,
            totalPages: 0
        }
        this.handlePageChange = this.handlePageChange.bind(this)
    }


    handlePageChange(event){
        this.setState({
            actualPage: event.target.value -1
        })
    }

    componentDidUpdate(prevProps){
        if (this.props.tableData !== prevProps.tableData){
            const columnIndex = this.props.columnOrderIndex
            this.props.tableData.sort(function (a, b) {
                if (a[columnIndex] > b[columnIndex]) {return 1;}
                if (a[columnIndex] < b[columnIndex]) {return -1;}
                return 0;
            })
            this.setState({
                orderedData: this.props.tableData,
                actualPage: 0,
                totalPages: Math.ceil(this.props.tableData.length / 10)
            })
        }
    }

    componentDidMount(){
        const {tableData, columnOrderIndex} = this.props
        tableData.sort(function (a, b) {
            if (a[columnOrderIndex] > b[columnOrderIndex]) {return 1;}
            if (a[columnOrderIndex] < b[columnOrderIndex]) {return -1;}
            return 0;
        })
        this.setState({
            orderedData: tableData,
            actualPage: 0,
            totalPages: Math.ceil(tableData.length / 10)
        })
    }

    render(){
        const {orderedData, actualPage, totalPages} = this.state
        const {headers} = this.props
        const {handlePageChange} = this
        const dataToShow = orderedData.slice(actualPage*10, actualPage*10 + 10)

        const getItemClass = (rowIndex, columnIndex) => {
            var classNameToUse = headers[columnIndex].small ? 'table-events-td-small' : 'table-events-td-large'
            if (rowIndex % 2){
                return `${classNameToUse} table-item-light`
            }
            return `${classNameToUse} table-item-dark`
        }

        const renderElement = (element, columnIndex, rowIndex) => {
            if (headers[columnIndex].render){
                if (headers[columnIndex].render === 'time'){
                    return parseTimestamp(element).time
                }
                if (headers[columnIndex].render === 'date'){
                    return parseTimestamp(element).date
                }
                if (headers[columnIndex].render === 'date-time'){
                    return `${parseTimestamp(element).date} ${parseTimestamp(element).time}`
                }
                if (headers[columnIndex].render === 'money'){
                    return `₡ ${element}`
                }
                if (headers[columnIndex].render === 'list'){
                    return `${element.replaceAll(",", "\n")}`
                }
                if (headers[columnIndex].render === 'link'){
                    return (
                        <div className="label-link" onClick={event => headers[columnIndex].func(rowIndex)}>
                            {element}
                        </div>
                    )
                }
                if (headers[columnIndex].render === 'checkBox'){
                    return (
                        <div className="label-link">
                            <input
                                type="checkbox"
                                checked={element}
                                onChange={event => headers[columnIndex].func(rowIndex)}
                            />
                        </div>
                    )
                }
                return 'UNKNOWN'
            }
            return element
        }

        const getPageNumberElement = () => {
            var pagesComponent = []
            for (var i = 0; i < totalPages; i++){
                pagesComponent.push(
                    <div className='label-link-container'>
                        <input
                            type="button"
                            className={i === actualPage ? "label-link-selected": "label-link"}
                            value={i + 1}
                            onClick={handlePageChange}
                        />
                    </div>
                )
            }
            return pagesComponent
        }
        return(
            <div className="table-events-container">
                <table className="table-events">
                    <tr>
                    {
                        headers.map(element => {
                            return (
                                <th className={element.small ? "table-events-th-small" : "table-events-th-large"}>
                                    {element.name}
                                </th>
                            )
                        })
                    }
                    </tr>
                    {
                        dataToShow.map((row, rowIndex) => {
                            return (
                                <tr className="display-reservations-table-tr">
                                {
                                    row.map((item, columnIndex) => {
                                        return (
                                            <td className={getItemClass(rowIndex, columnIndex)}>
                                                {renderElement(item, columnIndex, rowIndex)}
                                            </td>
                                        )
                                    })
                                }
                                </tr>
                            )
                        })
                    }
                </table>
                <div>
                    {
                        totalPages > 1 ?
                        getPageNumberElement() :<div></div>
                    }
                </div>
            </div>
        )
    }
}

export default GenericTable
